export const isCustomerPageContext = () => window.location.hostname.match(/(minesider|mypages|my-pages|pr-915)\./);
